const state = {
  // searchValue: '',
  map: null,
  zoom: 10,
  northeast: 0,
  southwest: 0,
  mapStatus: 1 // 地图状态，1-显示群标记，2-显示自动聚合，3-不聚合
}

export default state
